import { useCallback } from "react";

/**
 * SettingsToggle
 * Props:
 * - id?: string                   (optional DOM id)
 * - settingKey: string               Dexie setting key
 * - label: string                 Heading label
 * - description?: string          Short helper text below label
 * - defaultChecked?: boolean      Default if not in DB
 * - onChange?: (value:boolean) => void
 * - disabled?: boolean
 * - className?: string
 */
export function SettingsToggle({
  setting,
  onSettingChange,
  id,
  disabled = false,
  className = "",
}) {
  const {
    id: settingKey,
    value,
    label = "",
    description = "",
    options = [],
  } = setting;

  const handleChange = useCallback(
    async (e) => {
      const nextValue = !!e.target.checked; // toggle implies boolean
      const nextItem = { ...setting, value: nextValue };
      // Optimistic update via parent so UI stays in sync
      onSettingChange?.(nextItem);
    },
    [setting, onSettingChange]
  );

  const inputId = id || `setting-${settingKey}`;

  return (
    <label className="switch" htmlFor={inputId}>
      <input
        id={inputId}
        type="checkbox"
        checked={!!value}
        onChange={handleChange}
        disabled={disabled}
        aria-checked={!!value}
        aria-label={label || settingKey}
        name={settingKey}
      />
      <span className="slider round"></span>
    </label>
  );
}
